module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "call-button"
  }, [_c('ModalReveal', {
    staticClass: "p-0 m-0"
  }, [_vm._t("default", [_c('div', {
    staticClass: "pr-2 fa fa-phone fa-lg",
    staticStyle: {
      "color": "blue",
      "cursor": "pointer"
    }
  })], {
    "slot": "trigger"
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Number to call:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payload.external),
      expression: "payload.external"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.payload.external)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payload, "external", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Intern to use:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payload.internal),
      expression: "payload.internal"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.payload.internal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payload, "internal", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('button', {
    staticClass: "button action-button",
    class: {
      disabled: _vm.loading
    },
    on: {
      "click": _vm.requestCall
    }
  }, [_vm._v("Request call")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.loading) ? _c('span', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e()])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v(_vm._s(_vm.result))])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7379c167!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/CallButton.vue
// module id = 2524
// module chunks = 1